import {Box, Typography} from '@mui/material';
import React from 'react';
import "./Loader.css";
import "../../index.css";
import {FixedBox} from "../Common/FixedContainer";

const Loader = React.forwardRef((props, ref) => {
    return (
        <FixedBox ref={ref} {...props}>
            <Box className="loader" />
            <Typography sx={{fontSize: "0.75rem", letterSpacing: "1px", color: "text.secondary" }}>Gallery loading, please wait...</Typography>
        </FixedBox>
    );
})

export default Loader;
